import { useQuery } from "@apollo/client";
import { GET_REGISTRATION_BY_EXTERNAL_CODE } from "@/modules/gateway/features/open-external-sign/api/get-registration-by-external-code";

export function useRegistrationByCode({ code }: { code?: string } = {}) {
  const { data, loading, refetch } = useQuery(
    GET_REGISTRATION_BY_EXTERNAL_CODE,
    {
      variables: {
        code: code as string,
      },
      skip: !code,
    },
  );

  const registration = data?.getRegistrationByExternalCode;

  return {
    registration,
    loading,
    refetch,
  };
}
